module.exports = __webpack_public_path__ + "img/Group 138.b2fc6fb8.svg";